// NPM
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { isEmpty, map, forEach, isNil } from 'lodash';
import Slider from "react-slick";

// HOOK
import useSession from 'Hooks/session.hook';

// HELPERS
import { getInitials } from '../../shared/helpers/initial';
import { encode } from 'Helpers/enc';

// ANT COMPONENT
import {Col, Row, Space} from 'antd';
import { AvatarTitle, Avatar } from '@life-line-lab/components-react';

// STYLE
import './product-category.scss';

interface Category {
  name: string;
  imageUrl: string;
  href: string;
}

interface ProductCategoryProps {
  categories: Category[];
}

const ProductCategory: React.FC<ProductCategoryProps> = ({ categories }) => {

  const history = useHistory();
  const { t } = useTranslation();
  const { profile } = useSession();

  let settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 8,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 8,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3
          }
        }
      ]
  };


  if (isEmpty(categories)) {
    return null;
  }

  const onCategoryClick = (category) => {
    history.push('/products/catalog/list?name='+encode(category.name)+'&category='+encode(category._id))
  }

  let colProps = { xxl: 3, xl: 3, lg: 3, md: 6, sm: 8, xs: 12 }

  return (
    <div className="product-category">
      <div>
        <Slider {...settings}>
        {categories.length ? map(categories, (category, index) => {
          return (
              <div
                className="product-category--item"
                onClick={()=>onCategoryClick(category)}
                key={index}
              >
                <Row className="product-category--item-inner" gutter={8}>
                  <Col
                    onClick={() => history.push(category.href)}
                    className="product-image"
                    xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}
                  >
                    <div className="product-image--image">
                      {category.imageUrl ?
                        <img
                          alt={t('alt.category')}
                          src={category.imageUrl}
                        /> :
                        <React.Fragment>
                          <Avatar icon={getInitials(category.name, true)} shape="square" size="large"/>
                        </React.Fragment>}
                    </div>

                  </Col>
                  <Col
                    className="product-details text-center"
                    xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}
                  >
                    <Space direction="vertical" onClick={() => history.push(category.href)}>
                      <div className="product-details--name">{category.name}</div>
                    </Space>

                  </Col>

                </Row>
              </div>
          )
        }): null}
        </Slider>
      </div>
    </div>
  )
}

export default ProductCategory;
